<style>
	.edi-detail-bill .filter {
		background-color: #cbcbcb;
		padding: .4em .5em;
		margin-bottom: 1em;
	}
	.edi-detail-bill .filter input {
		background-color: white;
		-webkit-border-radius: .3125em;
		border-radius: .3125em;
		background-image: url('../assets/allorderbill/search.png');
		background-repeat: no-repeat;
		background-size: 25px;
		background-position: 2%;
	}
	.edi-detail-bill .detail-bill-status{
		background-color: #ffffff;
		padding: 1em;
		font-size: 1.0em;
		margin:1px;

	}
	.edi-detail-bill .detail-bill-status span{
		float:right;
		font-weight: normal;
	}
	.edi-detail-bill .detail-bill-status .nav-btn{
		margin-left:10px;
	}
	.edi-detail-bill .detail-bill-wrapper .list-btn{
		margin:-5px 10px 0px 0px;
	}
	.edi-detail-bill .bill-all-info {
		float:left;
		background-color: #ffffff;
		/*padding: 0em 1em;*/
		font-size: 1.0em;
	}
	.bill-all-info .detail-bill-info-list {
		float: left;
	}
	.bill-all-info .detail-bill-info-list li{
		float: left;
		width: 50%;
		/*margin:5px 0;*/
		padding:10px 1em;
		font-size: .8em;
		color: #656565;
		box-sizing: border-box;
		white-space: nowrap;
		border-bottom:1px solid #eee;
	}
	.bill-all-info .detail-bill-info-list .detail-bill-fulllist {
		width: 100%;
		white-space: normal;
		word-break: break-all;
	}
	.bill-all-info .detail-bill-info-list .detail-bill-to_organ_name {
		display: flex;
		flex-direction: row
	}
	.detail-bill-to_organ_name .to_organ_name-value {
		overflow: hidden;
		text-overflow:ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		white-space: normal;
		margin:0;
		flex:1;
	}
	.bill-all-info .detail-bill-info-list .detail-bill-remark{
		line-height: 2em;
	}
	.bill-all-info .detail-bill-info-list .detail-bill-delivery{
		line-height: 2em;
		flex:1;
		display: -webkit-box;
		overflow:hidden;
		text-overflow : ellipsis;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
	}
	.edi-detail-bill .detail-bill-search-wrapper{
		position: relative;
		display: flex;
		display: -webkit-flex;
		flex-direction: row;
		width: 100%;
		height: 41px;
		padding: 4px 8px;
		background-color: white;
		border-bottom: 1px solid #eee;
		box-sizing: border-box;
		overflow: hidden;
		line-height: 40px;
	}
	.detail-bill-search-wrapper .detail-search-input {
		display: inline-block;
		width: 100%;
		height: 32px;
		padding: 5px 5px 5px 35px;
		border: none;
		border-radius: 16px;
		box-sizing: border-box;
		background: #eee;
	}
	.detail-bill-search-wrapper:before {
		content: '';
		display: block;
		position: absolute;
		left: 20px;
		top: 50%;
		width: 16px;
		height: 16px;
		margin-top: -8px;
		background: url('../assets/search.png') no-repeat;
		background-size: contain;
	}
	.detail-bill-search-wrapper .detail-search-button {
		display: block;
		width: 50px;
		margin: 2px 0 2px 10px;
		background-color: #26a0a5;
		color: #fff;
		padding: 0 10px;
		vertical-align: middle;
		font-size: 16px;
		line-height: 28px;
		text-align: center;
		border-radius: 2px;
	}
	.edi-detail-bill .detail-bill-search-empty {
		position: relative;
		top: 35%;
		margin: 0 auto;
		width: 60%;
		height: 80px;
		text-align: center;
		font-style: normal;
		font-size: 16px;
		color: #666;
		letter-spacing: 2px;
	}
	.edi-detail-bill .detail-bill-search-empty p {
		display: inline-block;
		margin: 10px 0 0 0;
	}
	.edi-detail-bill .detail-bill-wrapper{
		background-color: #ffffff;
		float: left;
		width: 100%;
		/*margin-bottom:50px;*/
	}
	.edi-detail-bill .detail-bill-list{
		float: left;
	}
	.edi-detail-bill .detail-bill-list>li{
		color: #42a8ae;
		padding:1em;
		float: left;
		border-bottom: solid 1px #f1f1f1;
		box-sizing: border-box;
	}
	.edi-detail-bill .detail-bill-sonlist{
		float: left;
		margin-top: 5px;
	}
	.edi-detail-bill .detail-bill-sonlist li{
		float: left;
		width: 50%;
		margin:5px 0;
		font-size: .8em;
		color: #656565;
		box-sizing: border-box;
		white-space: nowrap;
	}
	.edi-detail-bill .detail-bill-sonlist .detail-bill-fulllist {
		float: left;
		width: 100%;
		margin:5px 0;
		font-size: .8em;
		color: #656565;
		box-sizing: border-box;
		white-space: normal;
		word-break: break-all;
	}
	.edi-detail-bill .detail-bill-sonlist .detail-bill-twolist {
		float: left;
		width: 50%;
		margin:5px 0;
		font-size: .8em;
		color: #656565;
		box-sizing: border-box;
		white-space: normal;
		word-break: break-all;
	}
	.edi-detail-bill .detail-bill-sonlist .detail-bill-list-title {
		color: #42a8ae;
		font-size: 1em;
		font-weight: 900;
		display: flex;
		position: relative;
		width: 100%;
		box-sizing: border-box;
	}
	.edi-detail-bill .detail-bill-address{
		margin:0;
		padding: 0.6em;
		border-bottom:solid 1px #f1f1f1;
		font-weight: normal;
	}
	.edi-detail-bill .detail-bill-footer{
		clear: both;
		float: left;
		width: 100%;
		height: 50px;
		background-color: #fff;
		position: absolute;
		bottom: 0%;
		box-shadow: 0px 10px 25px rgba(0,0,0,.5);
	}
	.edi-detail-bill .detail-bill-footer div{
		float: left;
		height: auto;
		box-sizing: border-box;
	}
	.edi-detail-bill .detail-bill-footer div.detail-bill-info{
		/*width: 50%*/
	}
	.edi-detail-bill .detail-bill-footer div.detail-bill-info p{
		position: relative;
		margin: 5px 0px;
	    font-size: 1em;
	    /*overflow: hidden;*/
	    text-overflow: ellipsis;
	    white-space: nowrap;
	}
	.edi-detail-bill .detail-bill-footer div.detail-bill-info p i{
		color: #0088cc;
		font-style: normal;
		position: absolute;
		overflow: hidden;
		text-overflow: ellipsis;
		width: 50%;
	}
	.edi-detail-bill .detail-bill-footer div.detail-bill-info p span.all-font{
		position: absolute;
		top: -45px;
		left: 50%;
		background-color: rgba(0,0,0,.5);
		color: #fff;
		padding: 5px 10px;
		border-radius: 5px;
		font-size: .8em;
	}

	.edi-detail-bill .detail-bill-footer div.detail-bill-agreen{
		width: 80px;
		text-align: center;
		height: 50px;
		line-height: 50px;
		background-color: #dedede;
	}
	.edi-detail-bill .detail-bill-footer div.detail-bill-agreen a{
		color: #787878;
		display: block;
	}
	.edi-detail-bill .detail-bill-footer div.detail-bill-return{
		width: 80px;
		text-align: center;
		height: 50px;
		line-height: 50px;
		background-color: #26a0a5;
	}
	.edi-detail-bill .detail-bill-footer div.detail-bill-return a{
		color: #fff;
		display: block;
	}
	.edi-detail-bill .detail-bill-footer div.detail-bill-red{
		width: 80px;
		text-align: center;
		height: 50px;
		line-height: 50px;
		background-color: #A42B3E;
	}
	.edi-detail-bill .detail-bill-footer div.detail-bill-red a{
		color: #fff;
		display: block;
	}
	/*.detail-scroll{
		height: 100%;
	}*/
	.detail-else-info{
		position: absolute;
	    left: 0;
	    bottom: 100%;
	    width: 100%;
	    background: #fff;
	    box-shadow: 0 -1px 1px rgba(0,0,0,0.3);
	}
	.detail-else-info p{
		margin: 0;
		padding: 10px;
		border-bottom: solid 1px #eee;
		color: #656565;
	}
	.detail-else-info .detail-else-info-list {
		display: flex;
	}
	.detail-else-info-list .detail-else-info-list-span {
		flex:1;
	}
	.detail-bill-total{
		display: inline-block;
		width: 50px;
		height: 50px;
		text-align: center;
		line-height: 50px;
		color: #42a8ae;
	}
	.detail-bill-total-btn{
		display: inline-block;
		width: 40px;
		height: 30px;
		text-align: center;
		line-height: 30px;
		color: white;
		background:#42a8ae;
		margin:10px 5px;
		border-radius: 2px;
	}
	.f-right{
		float: right !important;
	}
	/*附件添加删除按钮样式*/
	.attach-icon-plus,.attach-icon-minus{
		display: block;
		position: absolute;
		right: 0px;
		top: 6px;
		width: 24px;
		height: 24px;
		border-radius: 12px;
	}
	.attach-icon-plus{
		background: #6495ed;
	}
	.attach-icon-minus{
		background: #ea5d5d;
	}
	.attach-icon-plus:before,.attach-icon-minus:before{
		content: '';
		position: absolute;
		width: 16px;
		height: 2px;
		left: 50%;
		top: 50%;
		margin-left: -8px;
		margin-top: -1px;
		background-color: #ffffff;
	}
	.attach-icon-plus:after{
		content: '';
		position: absolute;
		width: 2px;
		height: 16px;
		left: 50%;
		top: 50%;
		margin-left: -1px;
		margin-top: -8px;
		background-color: #ffffff;
	}
	.mr25{
		margin-right: 25px;
	}
	.upload-img-style{
		height: 26px;
		margin-left: 15px;
		vertical-align: middle;
		margin-top: 10px;
	}
	.upload-img-del{
		position: absolute;
		top: 3px;
		right: -10px;
	}
	.r35{
		right: 35px;
	}
	.upload-file-div{
		margin: 0.6em 1.2em;
		font-size: 14px;
		position: relative;
	}
	.img-div{
		width: 60%;
		vertical-align: middle;
		display: inline-block;
	}
	.t10{
		top: 10px;
	}
	.bgGrey{
		background-color: grey !important;
	}
	.t0{
		top: 0px;
	}
	/* 更多按钮样式 */
	.edi-extra-btn-container {
		position: absolute;
		bottom: 50px;
		right: 100px;
		height: auto;
		display: flex;
		width: 60px;
		flex-flow: column-reverse nowrap;
		box-shadow: 0 -1px 2px 1px rgba(0,0,0,0.1);
	}
	.edi-extra-btn-container div {
		width: 100%;
		text-align: center;
	}
	.detail-bill-white {
		color: #eee;
	}
	.detail-bill-retrun-bgOrange {
		width: 80px;
		text-align: center;
		height: 50px;
		line-height: 50px;
		background-color: #F59A23;
	}
	.dlist-item-img {
		width: 50px!important;
		height: 50px!important;
		padding: 0!important;
		background: center no-repeat;
		background-size: 100%;
	}
	.dlist-item-img-span {
		margin-top: 16px;
	}
	.dlist-item-img>.dlist-item-img {
		margin-left: 5px;
	}
	.qrc {
		margin-left: 5px;
		padding-top: 16px;
	}
	.trisection-rows li{
		width: 33.33%!important;
	}
	.trisection-rows .detail-bill-fulllist{
		width: 100%!important;
	}
</style>
<template>
	<div class="edi-detail-bill">
		<!-- <div class="filter">
			<input type="text" placeholder="" class="ui-search-input"/>
		</div> -->
		<navbar title="餐企订单-明细"></navbar>
		<div v-show="scrollShow" class="common-scroll detail-scroll">
			<p class="detail-bill-status">{{detailData.trans_bill_no}}
				<span class="nav-btn" @click="openBillInfo()">
					<img src="../assets/nav-btn.png" alt="">
				</span>
				<span v-if="detailData.bill_state == 10" class="state-grey-font">未处理
				</span>
				<span v-if="detailData.bill_state == 11" class="state-aqua-font">待发货
				</span>
				<span v-if="detailData.bill_state == 12" class="state-orange-font">已发货
				</span>
				<span v-if="detailData.bill_state == 13" class="state-grey-font">已收货 待确认
				</span>
				<span v-if="detailData.bill_state == 14 || detailData.bill_state == 15 || detailData.bill_state == 16 || detailData.bill_state == 17" class="state-orange-font" style="background: #70B603">已收货 已确认
				</span>

				<span class="bill-state-inter">&nbsp;</span>
				<span v-if="detailData.weight_state == 0 && showDzcScaleappFlag" class="state-grey-font">未称重</span>
				<span v-if="detailData.weight_state == 1 && showDzcScaleappFlag" class="state-aqua-font">待称重</span>
				<span v-if="detailData.weight_state == 2 && showDzcScaleappFlag" class="state-orange-font">已称重</span>
			</p>
			<div class="bill-all-info" v-show="billInfoShow">
				<ul class="detail-bill-info-list">
					<li class="detail-bill-fulllist">订货企业：{{detailData.restaurant_name}}</li>
					<li class="detail-bill-fulllist">
						订货机构/时间：{{detailData.from_organ_name}}
						<span class="fr">{{detailData.from_date | dateFilterYMD}}</span>
					</li>
					<li class="detail-bill-fulllist detail-bill-to_organ_name">
						<p class="to_organ_name-value" v-if="detailData.billBusTypeID !== '0450_0030_0600_3'">收货机构/时间：{{detailData.to_organ_name}}</p>
						<p class="to_organ_name-value" v-else>门店名称/时间：{{detailData.to_organ_name}}</p>
						<span class="to_date-value">{{detailData.to_date | dateFilterYMD}}</span>
					</li>
					<li class="detail-bill-fulllist" v-if="detailData.billBusTypeID === '0450_0030_0600'">
						发货时间：
						<span v-if="editBillSendDate">{{detailData.sendDateStr}}
							<input type="datetime-local" v-model="billSendDate">
						</span>
						<span v-else>{{detailData.sendDateStr}}</span>
					</li>
					<li class="detail-bill-fulllist">
						收货人/联系方式：{{detailData.linkman}}
						<span class="fr">{{detailData.phone}}</span>
					</li>
					<li class="detail-bill-fulllist">
						收货地址：{{detailData.addr}}
					</li>
					<li class="detail-bill-fulllist detail-bill-remark">整单备注：{{detailData.remark}}</li>
					<li class="detail-bill-fulllist">
						<div class="detail-bill-delivery">
							发货描述：{{detailData.delivery_describe}}
						</div>
					</li>
					<li class="detail-bill-fulllist detail-bill-delivery">快递服务商：{{detailData.express_provider}}</li>
					<li class="detail-bill-fulllist detail-bill-delivery">快递单号：{{detailData.express_no}}</li>
					<li v-if="detailData.original_bill_id" class="detail-bill-fulllist detail-bill-delivery">第三方单号：{{detailData.original_bill_id}}</li>
				</ul>
			</div>
			<div class="detail-bill-search-wrapper">
				<input class="detail-search-input" placeholder="请输入要搜索的品项名称" v-model="searchWord">
			</div>
			<div class="detail-bill-wrapper">
				<div class="upload-file-div" v-if="uploadDeliverFlag !== undefined">
					<label>附件资料：</label>
					<upload-img
						:uploadImgList='uploadImgList'
						:imgListLength='10'
						:billState='detailData.bill_state'
						:jumpBill='jump_bill'
						:smallDelIco="smallDelIco"
						@update:smallDelIco='smallDelIco = $event'
						@attachDelPost='attachDelPost'
						@attachBeforeUpload='attachBeforeUpload'
						@attachClick='attachClick'
					></upload-img>
				</div>
				<h4 class="detail-bill-address aqua-font">
					<span class="list-btn fl" @click="openBillListInfo()">
						<img v-show= "!billListInfoShow" src="../assets/list_close.png" alt="">
						<img v-show= "billListInfoShow" src="../assets/list_open.png" alt="">
					</span>
					明细条目({{detailsFilter.length}})
					<router-link v-if="(billOtherData && billOtherData.isMiCunBanFan) && detailData.bill_state == 11 && !this.jump_bill" class="detail-bill-edit state-aqua-font" replace
						:to="{ path: '/detail-bill-edit', query: { bill_id: queryData.bill_id , searchWord: searchWord, send_date: billSendDate}}"
					>编辑</router-link>
					<router-link v-else-if="detailData.bill_state == 11 && !this.jump_bill" class="detail-bill-edit state-aqua-font" replace
						:to="{ path: '/detail-bill-edit', query: { bill_id: queryData.bill_id , searchWord: searchWord }}"
					>编辑</router-link>
				</h4>
				<ul class="detail-bill-list width-full">
					<li class="width-full" v-for="detail in detailsFilter">
						<ul class="detail-bill-sonlist width-full" :class="!showItemCodeFlag && !showActualAssisNumFlag && !showActualNumFlag ? 'trisection-rows' : ''">
							<li class="detail-bill-fulllist detail-bill-list-title">
								<w-img :src="detail.goods_picture" class="dlist-item-img" @on-click="attachClick(detail.goods_picture ?  (detail.goods_picture).replace(/\\/g, '/') : defaultImg)"></w-img>
								<span class="dlist-item-img-span">{{detail.goods_name}}<span v-if="(detail.goods_assist_unit ? showAssistUnitFlag: true) || isZ5">({{detail.goods_unit}})</span></span>
								<span class="fr silvery-font dlist-item-img-span" v-if="detailData.billBusTypeID !== '0450_0030_0600_3'">{{detail.inStoreName}}</span>
								<span class="fr silvery-font dlist-item-img-span" v-else>{{detail.inStoreName}}/{{detail.shopStoreName}}</span>
								<span class="qrc" v-show="!!detail.barcode" @click="barcodeClick(detail.barcode)"><img width="25" src="../assets/QRCode.jpg" alt=""></span>
							</li>
							<li class="detail-bill-fulllist" v-if="detail.goods_code && showItemCodeFlag">品项编号：{{detail.goods_code}}</li>
							<li class="detail-bill-twolist" v-if="isPesc">规格：{{detail.goods_spec}}</li>
							<li class="detail-bill-twolist" v-if="(detail.goods_assist_unit ? showAssistUnitFlag : true) || isZ5">订货数量：{{detail.goods_num | numFixed(4)}}</li>
							<li class="detail-bill-twolist" v-if="detail.bill_gross_weight">毛重：{{detail.bill_gross_weight | numFixed(4)}}</li>
							<li class="detail-bill-twolist" v-if="((detail.goods_assist_unit ? showAssistUnitFlag : true) && showActualNumFlag) || isZ5">发货数量：{{detail.goods_num_send | numFixed(4)}}</li>
							<li class="detail-bill-twolist" v-if="detailData.partial_delivery_flag === 1 && showActualNumFlag">已发数量：{{detail.goods_num_sended | numFixed(4)}}</li>
							<li class="detail-bill-twolist" v-if="detailData.partial_delivery_flag === 1 && showActualNumFlag">待发数量：{{detail.goods_num_wait_send | numFixed(4)}}</li>
							<li class="detail-bill-twolist" v-if="showMoneyFlag && !detailData.hiddenTax">价税合计：{{detail.sub_total_send}} 元</li>
							<li class="detail-bill-twolist" v-if="showActualNumFlag">实收数量：{{detail.goods_num_recipient | numFixed(4)}}</li>
							<li class="detail-bill-twolist" v-if="showMoneyFlag">实收金额：{{detail.sub_total_recipient}} 元</li>
							<div v-show="detail.goods_assist_unit">
								<li class="detail-bill-twolist" v-if="showActualAssisNumFlag">辅助单位：{{detail.goods_assist_unit}}</li>
								<li class="detail-bill-twolist">订货辅助数量：{{detail.goods_assist_num | numFixed(4)}}</li>
								<li class="detail-bill-twolist" v-if="showActualAssisNumFlag">发货辅助数量：{{detail.goods_assist_num_send | numFixed(4)}}</li>
								<li class="detail-bill-twolist" v-if="showActualAssisNumFlag">实收辅助数量：{{detail.goods_assist_num_recipient | numFixed(4)}}</li>
								<!-- <li class="detail-bill-twolist" style="height: 17px"></li> -->
							</div>
							<li class="detail-bill-twolist" style="color: red;" v-if="detailData.bill_state == 13 || detailData.bill_state == 15 || detailData.bill_state == 16 || detailData.bill_state == 17">差异数量：{{(detail.goods_num_send - detail.goods_num_recipient) | numFixed2(4)}}</li>
							<div v-show = "billListInfoShow">
								<li class="detail-bill-twolist" v-show="!detailData.hiddenTax">税率: {{detail.goods_cess}} %</li>
								<li class="detail-bill-twolist">订货单价：{{detail.goods_price}} 元</li>
								<li class="detail-bill-twolist"><span v-show="!detailData.hiddenTax">含税</span>(发货)单价：{{detail.goods_price_send}} 元</li>
								<!-- <li class="detail-bill-twolist"></li> -->
								<li class="detail-bill-fulllist" v-if="!(detail.remark == null || detail.remark == '' )">备注：{{detail.remark}}</li>
								<li v-if="detailData.bill_state == 13 || detailData.bill_state == 15 || detailData.bill_state == 16 || detailData.bill_state == 17">收货单价：{{detail.goods_price_recipient}} 元</li>
								<li v-if="detailData.bill_state == 13 || detailData.bill_state == 15 || detailData.bill_state == 16 || detailData.bill_state == 17">收货数量：{{detail.goods_num_recipient | numFixed(4)}}</li>
								<li v-if="detailData.bill_state == 13 || detailData.bill_state == 15 || detailData.bill_state == 16 || detailData.bill_state == 17">收货金额：{{detail.sub_total_recipient}} 元</li>
							</div>
						</ul>
					</li>
				</ul>
			</div>
			<div class="detail-bill-search-empty" v-if="!detailsFilter.length">
				<div class="middle-empty"></div>
				<p>未找到相关品项</p>
			</div>
		</div>
		<div v-show="scrollShow" class="detail-bill-footer">
			<div class="detail-else-info" v-show="show">
				<p v-if="false">配送至：{{detailData.to_organ_name}}</p>
				<!-- 需求:根据不同条件显示订货金额,发货金额,收货金额 订货数量,发货数量,收货数量-->
				<p class="detail-else-info-list" v-if="detailData.bill_state == 10 || detailData.bill_state == 11 || detailData.bill_state == 12 || detailData.bill_state == 13 || detailData.bill_state == 14 || detailData.bill_state == 15 || detailData.bill_state == 16 || detailData.bill_state == 17">
					<span class="detail-else-info-list-span">订货金额：{{detailData.sum_money | numFixed(numScale)}}元</span>
					<span class="detail-else-info-list-span">订货数量：{{sumGoodsNum | numFixed(4)}}</span>
				</p>
				<p class="detail-else-info-list" v-if="detailData.bill_state == 12 || detailData.bill_state == 13 || detailData.bill_state == 14 || detailData.bill_state == 15 || detailData.bill_state == 16 || detailData.bill_state == 17 || (detailData.bill_state == 11 && detailData.partial_delivery_flag === 1 && isGoodsNumSendedZero === false)">
					<span class="detail-else-info-list-span">发货金额：{{sumGoodsNumSendMoney | numFixed(numScale)}}元</span>
					<span class="detail-else-info-list-span">发货数量：{{sumGoodsNumSend | numFixed(4)}}</span>
				</p>
				<p class="detail-else-info-list" v-if="detailData.bill_state == 13 || detailData.bill_state == 14 || detailData.bill_state == 15 || detailData.bill_state == 16 || detailData.bill_state == 17 || (detailData.bill_state == 11 && detailData.partial_delivery_flag === 1 && isGoodsNumSendedZero === false)">
					<span class="detail-else-info-list-span">收货金额：{{detailData.sum_money_recipient | numFixed(numScale)}}元</span>
					<span class="detail-else-info-list-span">收货数量：{{sumGoodsNumRecipient | numFixed(4)}}</span>
				</p>
				<p class="detail-else-info-list" v-if="!isZ5">
					<span class="detail-else-info-list-span">订货辅助数量：{{sumGoodsAssistNum | numFixed(4)}}</span>
				</p>
				<p class="detail-else-info-list" v-if="!isZ5">
					<span class="detail-else-info-list-span">发货辅助数量：{{sumGoodsAssistNumSend | numFixed(4)}}</span>
				</p>
				<p class="detail-else-info-list" v-if="!isZ5">
					<span class="detail-else-info-list-span">收货辅助数量：{{sumGoodsAssistNumRecipient | numFixed(4)}}</span>
				</p>
			</div>
			<div class="detail-bill-info">
				<span class="detail-bill-total-btn" @click="infoExchange">合计</span>
			</div>
			<div v-if="detailData.bill_state == 10 && !this.jump_bill" class="detail-bill-return f-right">
				<a @click="agreen(11)">同意</a>
			</div>
			<div v-if="detailData.bill_state == 10 && refundFlag && !this.jump_bill" class="detail-bill-red f-right">
				<a @click="refuse">退回</a>
			</div>
			<div v-if="detailData.bill_state == 11 && isGoodsNumSendedZero === true && refundFlag && !this.jump_bill" class="detail-bill-red f-right">
				<a @click="refuse">退回</a>
			</div>
			<!-- 待发货的餐企订单 下发小程序-->
			<div v-if="detailData.bill_state == 11 && showDzcScaleappFlag" class="detail-bill-return detail-bill-retrun-bgOrange f-right" :class="{'bgGrey': uploadImgList.length === 0 && uploadDeliverFlag && !isZ5}">
				<a @click="onWeightMiniClick">小程序称重</a>
			</div>
			<!-- 不上传附件不能点击发货按钮  更多按钮组 -->
			<more-bottons v-if="detailData.bill_state == 11 && !this.jump_bill" :limitMoreButtons='1' class="f-right">
				<template slot="buttons">
					<div v-if="detailData.bill_state == 11 && !this.jump_bill" class="detail-bill-return f-right" :class="{'bgGrey': ((uploadImgList.length === 0 && uploadDeliverFlag) || (expressNoDeliveryFlag && detailData.express_no === ''))}">
						<a @click="askSend(false)">发货</a>
					</div>
					<div v-if="detailData.bill_state == 11 && detailData.partial_delivery_flag === 1 && !this.jump_bill" class="detail-bill-return detail-bill-retrun-bgOrange f-right" :class="{'bgGrey': uploadImgList.length === 0 && uploadDeliverFlag && !isZ5}">
						<a @click="askSend(true)">分批发货</a>
					</div>
				</template>
			</more-bottons>
			<!-- 需求:取消发货 2017/7/5 shang -->
			<div v-if="detailData.bill_state == 12 && !this.jump_bill" class="detail-bill-return f-right">
				<a @click="returnSend">取消发货</a>
			</div>
			<div v-if="detailData.bill_state != 10 && detailData.bill_state != 19 && !this.jump_bill && detailData.billBusTypeID!=='0400_0010_0200'" class="detail-bill-return f-right" style="border-right: solid 1px #fff">
				<a @click="importExcel">Excel</a>
			</div>
			<div v-if="detailData.bill_state == 13 && !this.jump_bill" class="detail-bill-return f-right" style="border-right: solid 1px #fff; background-color: #70B603;">
				<a @click="billStateConfirm">确认</a>
			</div>
		</div>
		<loading v-show="loading"></loading>
		<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
		<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" :tipsFontWaring="tipsWaring" v-on:tipStatus = "tipStatus"></tips>
		<tips v-show="tipsB" :btnNum = "btnNumB" :tipsFont = "tipsFont" :tipsFontWaring="tipsFontWaring" v-on:tipStatus = "tipStatusB"></tips>
		<tips-t :hasTipsFont="hasTipsFont" :btnFont="btnFont" :tipsFont="tipsFont" ref="tipsTShow" v-on:tipStatus = "getStatues" @onCancelTipStatus = "cancelDel"></tips-t>
		<item-img ref="itemImgRef"></item-img>
		<barcode-img ref="barcodeRef"></barcode-img>

		<fx-share v-model="copyPopShow">
			<template slot="mainContent">
				<div class="order-item-block">
					<div class="title-name">{{detailData.to_organ_name}} {{detailData.to_date | dateFilterYMD}}</div>
					<div class="text-word" v-if="detailData.linkman && detailData.phone">收货人/联系方式：{{detailData.linkman}} {{detailData.phone}}</div>
					<div class="text-word" v-if="detailData.addr">收货地址：{{detailData.addr}}</div>
					<div class="text-word" v-if="detailData.remark && isZ5">整单备注：{{detailData.remark}}</div>
					<div class="text-word" v-if="detailData.original_bill_id">第三方单号：{{detailData.original_bill_id}}</div>
					<div class="item-row" v-for="(good, index) in detailsFilter">
						<div class="item-info">
							{{ index + 1 }}、{{ good.goods_name + ((showShareHouseFlag && good.inStoreName)? '-' + good.inStoreName : '')}}：
							{{ ((good.goods_assist_unit ? showAssistUnitFlag : true) || isZ5) ? good.goods_num : good.goods_assist_num }}
							{{ ((good.goods_assist_unit ? showAssistUnitFlag : true) || isZ5) ? good.goods_unit : good.goods_assist_unit }}
							{{good.goods_assist_unit && (showAssistUnitFlag && isZ5) ? ' 辅助：' + good.goods_assist_num + good.goods_assist_unit : ''}}
						</div>
						<div class="item-remark" v-if="good.remark">备注：{{good.remark}}</div>
					</div>
				</div>
			</template>
		</fx-share>
		<side-float @on-click="copyPopShow = !copyPopShow"></side-float>
	</div>
</template>
<script>
import Loading from '../components/loading'
import TipsAuto from '../components/TipsAuto'
import Tips from '../components/Tips'
import TipsT from '../components/TipsT'
import NavBar from '../components/NavBar'
import { GlobalStore } from '../store/globalStore'
import ItemImg from '../components/ItemImg'
import UploadImg from '../components/Upload'
import BarcodeImg from '../components/BarcodeImg'
import MoreButtons from '../components/MoreButtons'
import FxShare from '../components/Fx-share'
import SideFloat from '../components/SideFloat'
export default {
	data () {
		return {
			isGoodsNumSendedZero: true,
			refundFlag: false,
			sendStatus: false,
			scrollShow: false,
			tips: false,
			tipsB: false,
			btnNum: 2,
			btnNumB: 3,
			show: false,
			tipsauto: false,
			sec: 1500,
			loading: true,
			detailData: {},
			billOtherData: null,
			details: [],
			accountInfo: {},
			btnFont: ['确定', '取消'],
			tipsFont: '用户尚未绑定邮箱',
			tipsWaring: false,
			email: '',
			hasTipsFont: true,
			queryData: this.$route.query,
			store: GlobalStore,
			sendInfo: {},
			allInfo: '',
			state: 0,
			numScale: 2,
			goodsTotalInfo: {},
			billInfoShow: false,
			billListInfoShow: false,
			tipsFontWaring: true,
			searchWord: '',
			isPesc: false, // 是否显示规格的系统参数
			smallDelIco: false,
			isZ5: false,
			uploadDeliverFlag: false, // 不上传附件不允许发单。undefined: 没有此功能；true: 不上传附件不允许发单；false: 不上传附件允许发单
			expressNoDeliveryFlag: false,
			uploadImgList: [],
			attachUploadUrl: '/cldEdi/business/bill/uploadEnclosure',
			trans_bill_id: '',
			defaultImg: require('../assets/detailPage/no-pic.png'),
			showAssistUnitFlag: true,
			showShareHouseFlag: true,
			jump_bill: false,
			showMoneyFlag: true,
			showActualNumFlag: true,
			showActualAssisNumFlag: true,
			showDzcScaleappFlag: false,
			copyPopShow: false,
			showItemCodeFlag: true,
			billSendDate: '',
			deliveryArrivalTimeDescFlag: false,
			supplierEDIConfirmDiff: false,
			hasReceiveDiff: false
		}
	},
	components: {
		'loading': Loading,
		'tips-auto': TipsAuto,
		'tips': Tips,
		'tips-t': TipsT,
		'navbar': NavBar,
		'item-img': ItemImg,
		'upload-img': UploadImg,
		'barcode-img': BarcodeImg,
		'more-bottons': MoreButtons,
		FxShare,
		SideFloat
	},
	beforeRouteLeave (to, from, next) {
		// if (this.skipRoute) {
		// 	next()
		// 	return
		// }
		// if (this.editStatus) {
		// 	next(false)
		// 	this.tipsTwoShow = true
		// } else {
		// 	next()
		// }
		console.log(this.detailData.bill_state)
		// 如果跳转明细编辑页面 也单据已经是已发单状态 则跳转单据主页面
		if (to.path === '/detail-bill-edit' && (this.detailData.bill_state === 12 || this.detailData.bill_state === 13)) {
			this.$router.go(-1)
		} else {
			next()
		}
	},
	created () {
		this.goodsTotalInfo = this.store.goodsTotalInfo
		this.getDetail().then((res) => {
			if (!res) {
				this.getUserInfo()
				this.getSendInfo()
			}
		})
		if (this.queryData.msg) {
			this.showMsg(this.queryData.msg)
		}
		this.$fxWeixin.registerWechatApi()
	},
	methods: {
		showMsg (msg) {
			this.autoTips(msg)
		},
		sendEmail () {
			// 对接导出excel并发送邮件接口
			this.loading = true
			var billId = {
				'bill_id': this.queryData.bill_id
			}
			this.$http.post('/cldEdi/business/8001', billId).then((response) => {
				this.loading = false
				var data = response.body
				if (data.result) {
					this.autoTips('邮件发送成功')
				} else {
					this.autoTips(data.message)
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		sendToWeight () {
			this.loading = true
			this.detailData.weight_state = 1
			return this.$http.post('/cldEdi/business/bill/updateWithDetail', this.detailData).then((response) => {
				this.loading = false
				var data = response.body
				if (!data.result) {
					this.autoTips(data.message)
					return
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		getSendInfo () {
			this.$http.post('/cldEdi/business/getSendSysUser').then(response => {
				var data = response.body
				if (data.result) {
					this.sendInfo = data.data
					window.console.log(this.sendInfo)
				} else {
					this.autoTips(data.message)
					return
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务中断，稍后请重试！')
				return
			})
		},
		getStatues (msg) {
			var temp = []
			temp = msg.split('+')
			switch (temp[0]) {
			case 'bindEmail':
				this.$router.push('/email-bind')
				this.goodsTotalInfo.emailLinksChange = true
				break
			case 'sendEmail':
				this.sendEmail()
				break
			case 'delAttach':
				this.attachDelPost(temp[1])
				break
			case 'billStateConfirm':
				this.billStateConfirms()
				break
			case 'billDiffConfirm':
				if (temp[1] === 'disagree') {
					this.agreen(17)
				} else {
					this.agreen(16)
				}
				break
			}
		},
		billStateConfirms () {
			this.agreen(14)
		},
		billStateConfirm () {
			if (this.isZ5 && this.supplierEDIConfirmDiff && this.hasReceiveDiff) {
				this.tipsFont = '订货数量与入库数量存在差异，是否同意差异？'
				this.btnFont = ['同意', '不同意', '关闭']
				this.tipsTShow('billDiffConfirm')
			} else {
				this.tipsFont = '是否确认该订单'
				this.btnFont = ['确认', '取消']
				this.tipsTShow('billStateConfirm')
			}
		},
		// 获取明细
		getDetail () {
			return new Promise((resolve, reject) => {
				this.loading = true
				var filterData = {
					bill_id: this.queryData.bill_id
				}
				this.$http.post('/cldEdi/business/billWithDetail', filterData).then((response) => {
					this.billOtherData = response.body.otherdata
					const forceUploadPermitFlag = (!response.body.otherdata || response.body.otherdata.forceUploadPermitFlag === null) ? false : response.body.otherdata.forceUploadPermitFlag
					this.isZ5 = response.body.otherdata == null ? false : response.body.otherdata.isZ5
					this.loading = false
					this.scrollShow = true
					if (!this.isZ5 && forceUploadPermitFlag === true) {
						this.$fxToast.warning('请上传供货商证照信息！')
						this.$router.replace({path: '/main/my'})
					}

					this.detailData = response.body.data
					this.billListInfoShow = this.detailData.details.some(item => {
						return item.remark !== null && item.remark !== ''
					})
					this.numScale = (this.detailData.number_scale || this.detailData.number_scale === 0) ? this.detailData.number_scale : 2
					this.details = response.body.data.details
					this.details.forEach(e => {
						if (e.goods_num > e.goods_num_sended) {
							e.goods_num_wait_send = e.goods_num - e.goods_num_sended
						} else {
							e.goods_num_wait_send = 0
						}
					})
					this.isPesc = this.detailData.isPesc // 是否显示规格的系统参数
					this.uploadDeliverFlag = response.body.otherdata == null ? undefined : response.body.otherdata.uploadDeliverFlag
					this.expressNoDeliveryFlag = response.body.otherdata == null ? undefined : response.body.otherdata.expressNoDeliveryFlag
					this.showAssistUnitFlag = response.body.otherdata == null ? true : response.body.otherdata.showAssistUnitFlag
					this.showShareHouseFlag = response.body.otherdata == null ? true : response.body.otherdata.order_show_sharehouse_flag // todo-wwwww
					this.showMoneyFlag = response.body.otherdata == null ? true : response.body.otherdata.order_show_money_flag
					this.showActualNumFlag = response.body.otherdata == null ? true : response.body.otherdata.order_show_sendrealnum_flag
					this.showActualAssisNumFlag = response.body.otherdata == null ? true : response.body.otherdata.order_show_assistnum_flag
					this.showDzcScaleappFlag = response.body.otherdata == null ? false : response.body.otherdata.dzcScaleappFlag
					this.refundFlag = response.body.otherdata == null ? true : response.body.otherdata.refundFlag
					this.showItemCodeFlag = response.body.otherdata == null ? true : response.body.otherdata.order_show_itemcode_flag
					this.deliveryArrivalTimeDescFlag = response.body.otherdata == null ? undefined : response.body.otherdata.deliveryArrivalTimeDescFlag
					this.trans_bill_id = this.detailData.trans_bill_id
					this.jump_bill = response.body.otherdata == null ? false : response.body.otherdata.jump_bill
					this.supplierEDIConfirmDiff = response.body.otherdata == null ? false : response.body.otherdata.supplierEDIConfirmDiff
					this.hasReceiveDiff = response.body.otherdata == null ? false : response.body.otherdata.hasReceiveDiff
					// 获取附件列表
					if (this.uploadDeliverFlag !== undefined) {
						this.getUploadPost()
					}
					this.details.forEach(e => {
						if (e.goods_num_sended !== 0) {
							this.isGoodsNumSendedZero = false
							return false
						}
					})
					if (this.billOtherData.isMiCunBanFan) {
						this.billSendDate = this.formatBillSendDate(this.detailData.send_date)
					}
					resolve(this.jump_bill)
				}, (response) => {
					this.loading = false
					this.autoTips('服务请求失败，稍后请重试！')
					reject()
				})
			})
		},
		// 获取附件列表
		getUploadPost () {
			const params = {
				id: this.isZ5 ? this.queryData.bill_id : this.trans_bill_id
			}
			this.$http.post('/cldEdi/business/bill/showEnclosure', params).then((response) => {
				var data = response.body
				if (data.result) {
					this.uploadImgList = data.data
				} else {
					this.autoTips(data.message)
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		getUserInfo () {
			// 获取邮箱信息
			this.$http.get('/cldEdi/business/getCurrentLoginUser').then((response) => {
				this.accountInfo = response.body.data
				this.email = this.accountInfo.email
			})
		},
		tipsTShow (str) {
			// 弹出操作提示框
			this.$refs.tipsTShow.open(str)
		},
		importExcel () {
			// 导出Excel
			// 1、判断邮箱是否绑定
			var val = this.email
			if (val === null) {
				// 未绑定邮箱，提示绑定邮箱
				this.tipsFont = '用户尚未绑定邮箱'
				this.btnFont = ['去绑定', '取消']
				this.tipsTShow('bindEmail')
			} else {
				// 已绑定邮箱，提示将excel发送至绑定邮箱
				this.tipsFont = '将单据导出Excel并发送至绑定邮箱'
				this.btnFont = ['确定', '取消']
				this.tipsTShow('sendEmail')
			}
		},
		infoExchange () {
			this.show = !this.show
		},
		tipStatus (msg) {
			this.tips = false
			this.msg = msg
			if (this.tipsWaring) {
				this.tipsWaring = false
				this.btnNum = 2
				return false
			}
			// window.console.log(this.state + ',' + this.msg)
			if (this.state === 19 && this.msg[1] === true) {
				this.refuseB()
				return false
			}
			// 发货
			if (this.state === 12 && this.msg[1] === true) {
				/* 系统参数为true，没有检测到附件则会弹出提示框，不允许发货 */
				this.agreen(12)
				return false
			}
			// 取消发货 2017/7/4 shang
			if (this.state === 99 && this.msg[1] === true) {
				this.agreen(99)
				return false
			}
		},
		tipStatusB (msg) {
			this.tipsB = false
			this.msg = msg
			if (this.state === 19 && this.msg[1] === true) {
				this.refuseBack()
				return false
			}
		},
		showAll (val) {
			clearTimeout(timer)
			this.allInfo = val
			var self = this
			self.show = true
			var timer = setTimeout(() => {
				self.show = false
			}, 5000)
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		agreen (state) {
			console.log(this.sendInfo)
			this.loading = true
			var goodsNumSendZero = 0
			this.details.forEach(e => {
				if (e.goods_num_send !== 0) {
					goodsNumSendZero++
				}
			})
			if (goodsNumSendZero === 0 && this.detailData.partial_delivery_flag === 1) {
				this.autoTips('整单数量为0的单据不允许发货!')
				this.loading = false
				return false
			}
			var updateData = {
				bill_state: state,
				id: this.detailData.id,
				plateNumber: this.sendInfo.plateNumber,
				sender: this.sendInfo.sender,
				senderPhone: this.sendInfo.senderPhone,
				sysparameter: this.sendInfo.sysparameter,
				addBatch_flag: this.sendStatus
			}

			if (state === 12) {
				updateData.sendDate = this.billSendDate ? this.$fxUtils.setDateTime(new Date(this.billSendDate)) : null
			}
			this.$http.post('/cldEdi/business/bill/updateBillState', updateData).then((response) => {
				this.loading = false
				var data = response.body
				if (data.result) {
					/* 根据需求,发货的单据有两种返回状态
					 * 13:已退回
					 * 12:已发货
					 */
					if (data.data && data.data.billState === 13) {
						this.detailData.bill_state = 13
						this.autoTips(data.message)
					} else {
						if (state === 99) {
							this.detailData.bill_state = 11
						} else {
							this.detailData.bill_state = state
						}
						this.autoTips('状态更新成功')
					}
					this.getDetail()
				} else {
					let str = ''
					if (data.otherdata) {
						if (Object.keys(data.otherdata).length !== 0) {
							if (data.otherdata.otherData[0].allZeroFlag === true) {
								this.autoTips(data.otherdata.otherData[0].msg)
							} else {
								data.otherdata.otherData.forEach(val => {
									if (!val.success) {
										str += val.itemId + ','
									}
								})
								str = '以下品项的入库量不允许超过订单量的一定范围:' + str.substr(0, str.length - 1)
								this.tipsFont = str
								this.btnNum = 1
								this.tipsWaring = true
								this.tips = true
							}
						} else {
							this.autoTips(data.message)
						}
					} else {
						this.autoTips(data.message)
					}
					return
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		refuse () {
			this.state = 19
			this.tips = true
			this.btnNum = 3
			this.tipsFont = '订单退回后将不可撤销，是否继续？'
		},
		refuseB () {
			this.state = 19
			this.tipsB = true
			this.btnNum = 3
			this.tipsFont = '确认退回订单？'
		},
		refuseBack () {
			this.loading = true
			var updateData = {
				bill_state: 19,
				id: this.detailData.id,
				plateNumber: this.sendInfo.plateNumber,
				sender: this.sendInfo.sender,
				senderPhone: this.sendInfo.senderPhone
			}
			// window.console.log(updateData)
			this.$http.post('/cldEdi/business/bill/updateBillState', updateData).then((response) => {
				this.loading = false
				var self = this
				var data = response.body
				if (data.result) {
					this.detailData.bill_state = 19
					// this.autoTips('订单已退回')
					this.autoTips('订单已退回')
					setTimeout(function () {
						self.$router.go(-1)
					}, 1500)
				} else {
					this.autoTips(data.message)
					return
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		askSend (status) {
			/* 如果不上传附件，不能发货。 系统参数为true时继续判断是否已上传*/
			if (this.uploadDeliverFlag !== undefined) {
				if (this.uploadDeliverFlag && this.uploadImgList.length === 0) {
					this.autoTips('不上传附件不允许发货')
					return
				}
			}
			if (this.expressNoDeliveryFlag !== undefined && !this.isZ5 && !status) { // 分批发货不考虑 不填写快递单号不允许发货
				if (this.expressNoDeliveryFlag) {
					if (this.billOtherData.isMiCunBanFan && (this.detailData.express_provider === '' || this.detailData.express_no === '')) {
						this.autoTips('不填写快递服务商、快递单号不允许发货')
						return
					} else if (!this.billOtherData.isMiCunBanFan && this.detailData.express_no === '') {
						this.autoTips('不填写快递单号不允许发货')
						return
					}
				}
			}
			if (this.deliveryArrivalTimeDescFlag !== undefined && !this.isZ5) {
				if (this.deliveryArrivalTimeDescFlag && this.detailData.delivery_describe === '') {
					this.autoTips('请填写发货描述')
					return
				}
			}
			if (status === true) {
				this.sendStatus = true
			} else {
				this.sendStatus = false
			}
			this.state = 12
			this.tips = true
			this.btnNum = 2
			this.tipsFont = '是否发货？'
		},
		// 取消发货 2017/7/4 shang
		returnSend () {
			this.state = 99
			this.tips = true
			this.btnNum = 2
			this.tipsFont = '是否取消发货？'
		},
		// 下发小程序称重
		onWeightMiniClick () {
			const billId = this.queryData.bill_id
			const { username, password, company_id, id } = this.accountInfo
			const domain4log = this.store.appURl
			if (!billId) {
				this.autoTips('单据ID错误')
				return
			}

			this.sendToWeight().then(() => {
				this.$fxConfirmSheetMini({
					message: '所选单据已经下发称重, 请到称重小程序进行称重操作',
					...this.$fxWeixin.mini.createMiniPramas('weight')({ username, password, domain4log, shop_id: company_id, user_id: id, ids: billId })
				}).then(() => {
					this.$fxConfirmSheet('是否已完成称重操作?').always(this.getDetail)
				})
			})
		},
		openBillInfo () {
			this.billInfoShow = !this.billInfoShow
		},
		openBillListInfo () {
			this.billListInfoShow = !this.billListInfoShow
		},
		// onDelClick (smallDelIco) {
		// 	this.smallDelIco = true
		// },
		// 删除或者预览
		// seeOrDel (list) {
		// 	if (this.smallDelIco) {
		// 		this.attachDel(list.id)
		// 	} else {
		// 		this.attachClick(list.path)
		// 	}
		// },
		attachAdd () {
			if (this.uploadImgList.length < 10) {
				this.$refs.attachInput.click()
			} else {
				this.autoTips('最多只能上传十个附件')
			}
		},
		attachDel (imgId) {
			this.btnFont = ['确定', '取消']
			this.tipsFont = '确定要删除附件吗？'
			this.tipsTShow('delAttach' + '+' + imgId)
		},
		attachBeforeUpload (attachFile, attachInput) {
			// 文件大小验证
			// let attachFile = e.target.files[0]
			// let attachFile = this.$refs.attachInput.files[0]
			// if (attachFile.size > 5 * 1024 * 1024) {
			// 	this.autoTips('文件大小不能超过5MB')
			// 	return false
			// }
			this.loading = true
			let uploadData = new window.FormData()
			uploadData.append('file', attachFile)
			uploadData.append('id', this.isZ5 ? this.queryData.bill_id : this.trans_bill_id)
			this.$http.post(this.attachUploadUrl, uploadData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((response) => {
				let data = response.body
				if (!data.result) {
					this.loading = false
					this.autoTips(data.data.cause || '上传附件失败')
				} else {
					if (data.data.success) {
						this.uploadImgList.push(data.data.billFiles)
						this.loading = false
						this.autoTips('上传附件成功')
					} else {
						attachInput.value = ''
						this.loading = false
						this.autoTips(data.data.cause)
					}
				}
			}, (response) => {
				attachInput.value = ''
				this.loading = false
				this.autoTips('请求失败，稍后请重试！')
			})
		},
		attachDelPost (imgId, attachInput) {
			let postData = {
				id: imgId
			}
			this.loading = true
			this.$http.post('/cldEdi/business/bill/deleteEnclosure', postData).then((response) => {
				let data = response.body
				if (!data.result) {
					this.loading = false
					this.autoTips(data.data.message || '删除附件失败')
				} else {
					attachInput.value = ''
					this.loading = false
					this.autoTips('删除附件成功')
					this.smallDelIco = false
					var tempArr = []
					this.uploadImgList.forEach((e) => {
						if (e.id !== imgId) {
							tempArr.push(e)
						}
					})
					this.uploadImgList = tempArr
				}
			}, (response) => {
				this.loading = false
				this.autoTips('请求失败，稍后请重试！')
			})
		},
		/* 点击预览图片 */
		attachClick (url) {
			this.$refs.itemImgRef.open(url)
		},
		barcodeClick (code) {
			this.$refs.barcodeRef.open(code)
		},
		// 取消删除附件回调事件
		cancelDel (msg) {
			this.smallDelIco = false
		},
		/* 上传附件结束 */
		// 差异数量排序
		sortByKey (array, key1, key2) {
			return array.sort(function (a, b) {
				var x = a[key1] - a[key2]
				var y = a[key1] - a[key2]
				return ((x < y) ? -1 : ((x > y) ? 1 : 0))
			})
		},
		formatBillSendDate (d) {
			if (!d || d.indexOf('1970-01-01') === 0) {
				d = new Date()
			} else {
				d = this.$fxUtils.newDate(d)
			}

			var currentDate = this.$fxUtils.setDateTime(d, '时分')
			return currentDate
		}
	},
	filters: {
		// edi小数位数处理
		numFixed (val, scale) {
			// if ((typeof val === 'string' && val !== '') || typeof val === 'number') {
			// 	if (scale) {
			// 		return val.toFixed(scale)
			// 	} else {
			// 		return val
			// 	}
			// } else {
			return val
			// }
		},
		numFixed2 (val, scale) {
			if ((typeof val === 'string' && val !== '') || typeof val === 'number') {
				if (scale) {
					return parseFloat(val.toFixed(scale))
				} else {
					return val
				}
			} else {
				return val
			}
		}
	},
	computed: {
		detailsFilter () {
			if (this.searchWord.trim()) {
				let filterDetail = this.details.filter(detail => detail.goods_name.indexOf(this.searchWord.trim()) >= 0)
				return this.sortByKey(filterDetail, 'goods_num_send', 'goods_num_recipient')
			} else {
				return this.sortByKey(this.details, 'goods_num_send', 'goods_num_recipient')
			}
		},
		editBillSendDate () {
			if (!this.detailData || !this.billOtherData) {
				return false
			}
			return this.detailData.bill_state === 11 && this.billOtherData.isMiCunBanFan && this.detailData.send_date.indexOf('1970-01-01') >= 0
		},
		sumGoodsNum () {
			let sumGoodsNum = 0
			if (this.details) {
				for (let i = 0; i < this.details.length; i++) {
					sumGoodsNum += this.details[i].goods_num
				}
			}
			return sumGoodsNum
		},
		sumGoodsNumSend () {
			let sumGoodsNumSend = 0
			if (this.details) {
				for (let i = 0; i < this.details.length; i++) {
					sumGoodsNumSend += this.details[i].goods_num_send
				}
			}
			return sumGoodsNumSend
		},
		sumGoodsNumSendMoney () {
			let sumGoodsNumSendMoney = 0
			if (this.details) {
				for (let i = 0; i < this.details.length; i++) {
					sumGoodsNumSendMoney += this.details[i].sub_total_send
				}
			}
			return sumGoodsNumSendMoney
		},
		sumGoodsNumRecipient () {
			let sumGoodsNumRecipient = 0
			if (this.details) {
				for (let i = 0; i < this.details.length; i++) {
					sumGoodsNumRecipient += this.details[i].goods_num_recipient
				}
			}
			return sumGoodsNumRecipient
		},
		sumGoodsAssistNum () {
			let sumGoodsAssistNum = 0
			if (this.details) {
				for (let i = 0; i < this.details.length; i++) {
					sumGoodsAssistNum += this.details[i].goods_assist_num
				}
			}
			return sumGoodsAssistNum
		},
		sumGoodsAssistNumSend () {
			let sumGoodsAssistNumSend = 0
			if (this.details) {
				for (let i = 0; i < this.details.length; i++) {
					sumGoodsAssistNumSend += this.details[i].goods_assist_num_send
				}
			}
			return sumGoodsAssistNumSend
		},
		sumGoodsAssistNumRecipient () {
			let sumGoodsAssistNumRecipient = 0
			if (this.details) {
				for (let i = 0; i < this.details.length; i++) {
					sumGoodsAssistNumRecipient += this.details[i].goods_assist_num_recipient
				}
			}
			return sumGoodsAssistNumRecipient
		}
	}
}
</script>



// WEBPACK FOOTER //
// DetailBill.vue?3708e510